import { MinusIcon } from "../../assets/icons/MinusIcon";
import { PlusIcon } from "../../assets/icons/PlusIcon";
import { TrashIcon } from "../../assets/icons/TrashIcon";

export const ItemQty = ({qty, setQty, onChange, onDelete, disabled}) => {

    //FUNCTIONS
    const remove = () => {
        if (disabled)
        {
            return;
        }

        if (qty > 1) {
            setQty(qty - 1);

            if (onChange) {
                onChange(qty - 1);
            }
        } else {
            if (onDelete) {
                onDelete();
            }
        }
    }

    const add = () => {
        if (disabled)
        {
            return;
        }

        setQty(qty + 1);

        if (onChange) {
            onChange(qty + 1);
        }
    }
    
    return (
        <div className='product_qty'>
            <span className={qty === 1 ? 'less_button trash' : 'less_button'} onClick={remove}>
                {
                    qty === 1 ? <TrashIcon /> : <MinusIcon />
                }
            </span>
            <div className='qty_input'>
                {qty}
            </div>
            <span className='plus_button' onClick={add}>
                <PlusIcon />
            </span>
        </div>
    );
}